import * as partnersServices from './partnersServices';

export { partnersServices };
